module.exports = __webpack_public_path__ + "img/interview_new.baedea54.svg";